// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"a681601a","300":"0278ab83","429":"7b53a612","625":"0278ab83","635":"81e2dfae","724":"7b53a612","904":"0278ab83","976":"0278ab83"}[chunkId] + ".chunk.css";
};